import React from 'react';
import { Modal, Typography } from 'antd';

const { Text } = Typography;

interface VerifyModalProps {
  open: boolean;
  formId: string | null;
  pagePath: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const VerifyModal: React.FC<VerifyModalProps> = ({
  open,
  formId,
  pagePath,
  onConfirm,
  onCancel,
  loading,
}) => {
  return (
    <Modal
      title="完成驗收確認"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="確認驗收通過"
      cancelText="取消"
      confirmLoading={loading}
      okButtonProps={{ type: 'primary' }}
    >
      <div style={{ padding: '16px 0' }}>
        <p>確認此頁面/模組已通過審查，無需修改？</p>
        <div style={{ marginTop: 12, padding: 12, background: '#fafafa', borderRadius: 6 }}>
          <div>
            <Text type="secondary">頁面：</Text>
            <Text strong>{pagePath}</Text>
          </div>
          {formId && (
            <div style={{ marginTop: 4 }}>
              <Text type="secondary">模組：</Text>
              <Text strong>{formId}</Text>
            </div>
          )}
        </div>
        <p style={{ marginTop: 16, color: '#8c8c8c', fontSize: 13 }}>
          驗收通過後，模組狀態將更新為「完成」。
        </p>
      </div>
    </Modal>
  );
};

export default VerifyModal;
